<template>
  <div class="centered">
    <h1 class="white--text">Oops!</h1>
    <h3 class="white--text">The page you're looking for is not here.</h3>
    <router-link :to="{ name: 'GenericMapPage', params: { slug: 'realtime'} }" class="link-color"
      >Back to home or login page</router-link
    >
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.centered {
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.link-color {
  color: white;
}
</style>
